import { render, staticRenderFns } from "./CardMaterial.vue?vue&type=template&id=6ef4b9ce&"
import script from "./CardMaterial.vue?vue&type=script&lang=js&"
export * from "./CardMaterial.vue?vue&type=script&lang=js&"
import style0 from "./CardMaterial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports